import { Lightning } from '@lightningjs/sdk';
import _merge from 'lodash/merge';
import { ICON_COLLECTION } from '@tornado-rdk/icons';
import Icon from '../icon/icon.component';
import {
  defaultContext,
  getDisabledStyle,
  getFocusedStyle,
  getInitialStyle,
  getUnFocusedStyle,
  SIZE,
} from './navigationArrow.style';
import { ARROW_LEFT, ARROW_RIGHT } from './navigationArrow.constants';

export class NavigationArrow extends Lightning.Component {
  static _template() {
    return _merge(
      {
        Background: {
          rect: true,
          shader: {
            type: Lightning.shaders.RoundedRectangle,
          },
        },
        Icon: {
          type: Icon,
        },
      },
      getInitialStyle(),
    );
  }

  _construct() {
    this._style = defaultContext;
    this._disabled = false;
    this._focused = false;
  }

  get disabled() {
    return this._disabled;
  }

  set disabled(value) {
    if (value === this._disabled) {
      return;
    }

    this._disabled = value;

    if (this._disabled) {
      this.patch(getDisabledStyle(this._style));
    } else if (this._focused) {
      this.patch(getFocusedStyle(this._style));
    } else {
      this.patch(getUnFocusedStyle(this._style));
    }
  }

  set variant(value) {
    if (value !== ARROW_LEFT && value !== ARROW_RIGHT) {
      return;
    }

    const size = Math.round(SIZE[this._style.screenSize] / 2);

    this.tag('Icon').iconData = {
      picto: { name: value, collection: ICON_COLLECTION.BASIC },
      viewBox: { w: size, h: size },
    };
  }

  _focus() {
    if (this._disabled) {
      this.patch(getDisabledStyle(this._style));

      return;
    }

    this.patch(getFocusedStyle(this._style));
    this._focused = true;
  }

  _unfocus() {
    if (this._disabled) {
      this.patch(getDisabledStyle(this._style));
    } else {
      this.patch(getUnFocusedStyle(this._style));
    }
    this._focused = false;
  }
}
